/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const listSensors = /* GraphQL */ `query ListSensors {
  listSensors {
    sensorId
    name
    enabled
    geo {
      latitude
      longitude
      __typename
    }
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSensorsQueryVariables,
  APITypes.ListSensorsQuery
>;
export const getTenant = /* GraphQL */ `query GetTenant($id: ID!) {
  getTenant(id: $id) {
    id
    tenantname
    subtenant
    address
    contact
    phone
    status
    servicepackage
    statuspayment
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTenantQueryVariables, APITypes.GetTenantQuery>;
export const listTenants = /* GraphQL */ `query ListTenants(
  $filter: ModelTenantFilterInput
  $limit: Int
  $nextToken: String
) {
  listTenants(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantname
      subtenant
      address
      contact
      phone
      status
      servicepackage
      statuspayment
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTenantsQueryVariables,
  APITypes.ListTenantsQuery
>;
export const getVehicleAlarm = /* GraphQL */ `query GetVehicleAlarm($id: ID!) {
  getVehicleAlarm(id: $id) {
    id
    vehiclecode
    alarm
    timestamps
    vehicleID
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetVehicleAlarmQueryVariables,
  APITypes.GetVehicleAlarmQuery
>;
export const listVehicleAlarms = /* GraphQL */ `query ListVehicleAlarms(
  $filter: ModelVehicleAlarmFilterInput
  $limit: Int
  $nextToken: String
) {
  listVehicleAlarms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      vehiclecode
      alarm
      timestamps
      vehicleID
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVehicleAlarmsQueryVariables,
  APITypes.ListVehicleAlarmsQuery
>;
export const vehicleAlarmsByVehicleID = /* GraphQL */ `query VehicleAlarmsByVehicleID(
  $vehicleID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelVehicleAlarmFilterInput
  $limit: Int
  $nextToken: String
) {
  vehicleAlarmsByVehicleID(
    vehicleID: $vehicleID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      vehiclecode
      alarm
      timestamps
      vehicleID
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VehicleAlarmsByVehicleIDQueryVariables,
  APITypes.VehicleAlarmsByVehicleIDQuery
>;
export const getVehicle = /* GraphQL */ `query GetVehicle($id: ID!) {
  getVehicle(id: $id) {
    id
    vehiclecode
    typevehicle
    location
    status
    VehicleAlarms {
      nextToken
      __typename
    }
    category
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetVehicleQueryVariables,
  APITypes.GetVehicleQuery
>;
export const listVehicles = /* GraphQL */ `query ListVehicles(
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  listVehicles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      vehiclecode
      typevehicle
      location
      status
      category
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVehiclesQueryVariables,
  APITypes.ListVehiclesQuery
>;
export const getTyreAlarm = /* GraphQL */ `query GetTyreAlarm($id: ID!) {
  getTyreAlarm(id: $id) {
    id
    serialnumber
    sensorid
    brand
    typetyre
    vehiclecode
    position
    alarms
    timestamps
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTyreAlarmQueryVariables,
  APITypes.GetTyreAlarmQuery
>;
export const listTyreAlarms = /* GraphQL */ `query ListTyreAlarms(
  $filter: ModelTyreAlarmFilterInput
  $limit: Int
  $nextToken: String
) {
  listTyreAlarms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      serialnumber
      sensorid
      brand
      typetyre
      vehiclecode
      position
      alarms
      timestamps
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTyreAlarmsQueryVariables,
  APITypes.ListTyreAlarmsQuery
>;
export const getTyre = /* GraphQL */ `query GetTyre($id: ID!) {
  getTyre(id: $id) {
    id
    serialnumber
    brand
    typetyre
    vehiclecode
    position
    sensorid
    pressure
    temperature
    battery
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTyreQueryVariables, APITypes.GetTyreQuery>;
export const listTyres = /* GraphQL */ `query ListTyres(
  $filter: ModelTyreFilterInput
  $limit: Int
  $nextToken: String
) {
  listTyres(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      serialnumber
      brand
      typetyre
      vehiclecode
      position
      sensorid
      pressure
      temperature
      battery
      status
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTyresQueryVariables, APITypes.ListTyresQuery>;
export const getAdmin = /* GraphQL */ `query GetAdmin($id: ID!) {
  getAdmin(id: $id) {
    id
    nik
    name
    email
    position
    tenant
    username
    password
    accessrole
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetAdminQueryVariables, APITypes.GetAdminQuery>;
export const listAdmins = /* GraphQL */ `query ListAdmins(
  $filter: ModelAdminFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdmins(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      nik
      name
      email
      position
      tenant
      username
      password
      accessrole
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminsQueryVariables,
  APITypes.ListAdminsQuery
>;
export const getSensorValue = /* GraphQL */ `query GetSensorValue($id: ID!) {
  getSensorValue(id: $id) {
    id
    sensorId
    pH
    temperature
    salinity
    disolvedO2
    status
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSensorValueQueryVariables,
  APITypes.GetSensorValueQuery
>;
export const listSensorValues = /* GraphQL */ `query ListSensorValues(
  $filter: ModelSensorValueFilterInput
  $limit: Int
  $nextToken: String
) {
  listSensorValues(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      sensorId
      pH
      temperature
      salinity
      disolvedO2
      status
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSensorValuesQueryVariables,
  APITypes.ListSensorValuesQuery
>;
